module.exports = __webpack_public_path__ + "static/bronze_scout-088a92d73794c1adf817e51f8847e295.png";